import './about.css';
import { useState, useEffect } from 'react';
import SoftBlob from './SoftBlob';

function About() {
  const centeredRandom_1 = () => {
    // 6回平均でかなりギュッと
    let total = 0;
    for (let i = 0; i < 20; i++) total += Math.random();
    return total / 20;
  };
  const centeredRandom_2 = () => {
    // 6回平均でかなりギュッと
    let total = 0;
    for (let i = 0; i < 15; i++) total += Math.random();
    return total / 15;
  };

  const [blobSize, setBlobSize] = useState(250);

  useEffect(() => {
    const handleResize = () => {
      setBlobSize(window.innerWidth <= 620 ? window.innerWidth <= 400 ? 100 : 120 : 250);
    };

    handleResize(); // 初期サイズ判定
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const bubbles_1 = Array.from({ length: 50 }, (_, i) => {
    const animIndex1 = Math.floor(Math.random() * 5);
    return (
      <div
        className={`bubble bubble-anim-${animIndex1}`}
        style={{
          top: `${centeredRandom_1() * 280}px`,
          animationDelay: `${Math.random() * 8}s`,
          width: "15px",
          height: "15px"
        }}
        key={i}
      />
    );
  });  
  const bubbles_2 = Array.from({ length: 50 }, (_, i) => {
    const animIndex2 = Math.floor(Math.random() * 5 + 5);
    return (
      <div
        className={`bubble bubble-anim-${animIndex2}`}
        style={{
          top: `${centeredRandom_2() * 280}px`,
          animationDelay: `${Math.random() * 8}s`,
          width: "15px",
          height: "15px"
        }}
        key={i}
      />
    );
  });

  return (
    <div className='about'>
      <div className='about-text'>
        <h3>人を集めてつなげて広げて</h3>
      </div>   
      <div className='about-container'>
        <div className='about-background'>
          <h1>▶︎</h1>
        </div>
        <div className="about-fig">
          <div className="about-bubbles">
            {bubbles_1}
          </div>
          <div className="circle-wrapper">
            <SoftBlob width={blobSize} height={blobSize} />
            <div className="circle-label">
              <div className="circle-number">92人</div>
              <div className="circle-text">メンバー数</div>
            </div>
          </div>


          <div className="circle-wrapper">
            <SoftBlob width={blobSize} height={blobSize} />
            <div className="circle-label">
              <div className="circle-number">15件</div>
              <div className="circle-text">関連団体</div>
            </div>
          </div>

          <div className="about-bubbles">
            {bubbles_2}
          </div>
        </div>
      </div>
    </div>
  );
}


export default About;
